import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-red-accent text-text-primary',
        secondary: 'border-transparent bg-surface-raised text-text-secondary',
        outline: 'border-border text-text-secondary',
        success: 'border-transparent bg-green-ok/20 text-green-ok',
        warning: 'border-transparent bg-amber-warn/20 text-amber-warn',
        destructive: 'border-transparent bg-red-subtle text-red-accent',
        info: 'border-transparent bg-cyan-info/20 text-cyan-info',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
